import WrappedLayout from "./wrap-page-element"
export const wrapPageElement = WrappedLayout

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`)
  }
}
